/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './export.tpl.html';

angular
  .module('chatter.export', [])
  .constant('EXPORT_STATE', {
    STARTED: 'STARTED',
    FINISHED: 'FINISHED'
  })
  /**
   * Controller for the chatter.export template.
   */
  .controller(
    'ChatterExportCtrl',
    function (
      $scope,
      httpBatch,
      $filter,
      batchUtils,
      progressFactory,
      exportBatch,
      CHATTER_SIZES,
      EXPORT_STATE,
      RESULT_KEYS
    ) {
      var origExportState = exportBatch.state;

      if (origExportState === EXPORT_STATE.FINISHED) {
        progressFactory.disableProgress();
      }

      /**
       * Utility function to set the scope vars for the batch export
       */
      function setExportBatchData(batch) {
        var expireDate = moment(batch.exportData.expires * 1000),
          exportDate = moment(batch.date),
          objectTotal = _.size(batch.typeCounts),
          exportSize = $filter('fromBytes')(batch.exportData.size),
          batchTypeText =
            batch.type === 'BULK_RESTORE_PREVIEW' ? $filter('i18n')('RESTORE_PREVIEW') : $filter('i18n')('EXPORT');

        if (moment().isAfter(expireDate)) {
          $scope.expired = true;
        } else {
          $scope.expired = false;
        }

        $scope.exportBatch = batch;
        $scope.isCancelled = $scope.exportBatch.status === RESULT_KEYS.CANCELLED;
        $scope.batchUtils = batchUtils;
        $scope.EXPORT_STATE = EXPORT_STATE;
        $scope.expireDate = $filter('i18n')('BATCH_DATE', [expireDate.format('l'), expireDate.format('h:mm a')]);

        if ($scope.isCancelled) {
          $scope.expireText = $filter('i18n')('BATCH_EXPORT_DETAIL_DATE_CANCELLED', [
            batchTypeText,
            exportDate.format('MMM D[,] YYYY h:mm A')
          ]);
        } else {
          $scope.expireText = $filter('i18n')('BATCH_EXPORT_DETAIL_DATE', [
            batchTypeText,
            exportDate.format('MMM D[,] YYYY h:mm A'),
            objectTotal,
            exportSize
          ]);
        }
      }

      // Setup the scope values for the initial load of the controller
      setExportBatchData(exportBatch);

      // Watches to resize the canvas app based on the current state of the backup.
      $scope.$watch('exportInProgress ', function () {
        if (!$scope.exportInProgress || exportBatch.state === EXPORT_STATE.FINISHED) {
          // if the original exportStatus was not Finished then load the batch.
          if (origExportState !== EXPORT_STATE.FINISHED) {
            httpBatch.getBatch($scope.stateParams.batchId).then(function (batch) {
              setExportBatchData(batch);
            });
          }

          if (!progressFactory.disabled) {
            progressFactory.disableProgress();
          }
        }
      });

      /**
       * Handler to show export details page in app.
       */
      $scope.showExportInApp = function () {
        // Use the chatter gotoApp function.
        $scope.gotoApp('?batchId=' + $scope.stateParams.batchId + '&page=exportDetails');
      };

      /**
       * Handler for the download export button.
       */
      $scope.downloadExport = function () {
        window.location = $scope.exportBatch.exportData.url;
      };
    }
  );
